import React from 'react';
import ExerciseList from "fit/pages/strength/ExerciseList";

const ExerciseListRoute=()=>{
    return <ExerciseList/>
}

export default ExerciseListRoute;